import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export function Cursor() {
  const x = useMotionValue(-200);
  const y = useMotionValue(-200);
  const ringX = useSpring(x, { stiffness: 260, damping: 24, mass: 0.6 });
  const ringY = useSpring(y, { stiffness: 260, damping: 24, mass: 0.6 });
  const spotX = useSpring(x, { stiffness: 55, damping: 20 });
  const spotY = useSpring(y, { stiffness: 55, damping: 20 });
  const [hovering, setHovering] = useState(false);
  const [pressed, setPressed] = useState(false);

  useEffect(() => {
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    const over = (e) => setHovering(!!e.target.closest("a,button,[role='button'],input,select,textarea,label"));
    const down = () => setPressed(true);
    const up = () => setPressed(false);
    window.addEventListener("mousemove", move, { passive: true });
    window.addEventListener("mouseover", over, { passive: true });
    window.addEventListener("mousedown", down);
    window.addEventListener("mouseup", up);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
      window.removeEventListener("mousedown", down);
      window.removeEventListener("mouseup", up);
    };
  }, [x, y]);

  return (
    <div aria-hidden="true" className="hidden md:block" data-testid="custom-cursor">
      <motion.div className="pointer-events-none fixed left-0 top-0 z-[40]" style={{ x: spotX, y: spotY }}>
        <div
          className="-translate-x-1/2 -translate-y-1/2 rounded-full"
          style={{
            width: 560,
            height: 560,
            background: "radial-gradient(circle, rgba(201,162,39,0.06), rgba(184,190,199,0.03) 42%, transparent 65%)",
          }}
        />
      </motion.div>

      <motion.div className="pointer-events-none fixed left-0 top-0 z-[300]" style={{ x, y }}>
        <div
          className={`-translate-x-1/2 -translate-y-1/2 rounded-full bg-[#C9A227] shadow-[0_0_12px_rgba(201,162,39,0.9)] transition-[width,height] duration-200 ${
            hovering ? "h-1.5 w-1.5" : "h-2 w-2"
          }`}
        />
      </motion.div>

      <motion.div className="pointer-events-none fixed left-0 top-0 z-[300]" style={{ x: ringX, y: ringY }}>
        <div
          className={`-translate-x-1/2 -translate-y-1/2 rounded-full border transition-[width,height,border-color,background-color,box-shadow,transform] duration-300 ${
            hovering
              ? "h-14 w-14 border-[#C9A227] bg-[#C9A227]/10 shadow-[0_0_28px_rgba(201,162,39,0.35)]"
              : "h-9 w-9 border-[#EDF1F6]/50 bg-transparent"
          } ${pressed ? "scale-75" : "scale-100"}`}
        />
      </motion.div>
    </div>
  );
}
